exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3ab4f6c7] .el-card__body{height:100%}.card__body--nopadding[data-v-3ab4f6c7]  .el-card__body{padding:10px}.to-model-preview[data-v-3ab4f6c7]{cursor:pointer}.model_message_wrap[data-v-3ab4f6c7]{background-color:#f5f5f5!important;color:#000!important}.model_message_wrap[data-v-3ab4f6c7]  .el-checkbox__inner{border-color:#000!important}.modelTree-tree[data-v-3ab4f6c7]{height:calc(100% - 84px)}", ""]);

// exports
